import { jsx, jsxs } from "react/jsx-runtime";
import { Avatar, XStack } from "tamagui";
function AvatarDemo() {
  return /* @__PURE__ */ jsxs(XStack, { alignItems: "center", space: "$6", children: [
    /* @__PURE__ */ jsxs(Avatar, { circular: true, size: "$10", children: [
      /* @__PURE__ */ jsx(
        Avatar.Image,
        {
          accessibilityLabel: "Cam",
          src: "https://images.unsplash.com/photo-1548142813-c348350df52b?&w=150&h=150&dpr=2&q=80"
        }
      ),
      /* @__PURE__ */ jsx(Avatar.Fallback, { backgroundColor: "$blue10" })
    ] }),
    /* @__PURE__ */ jsxs(Avatar, { circular: true, size: "$8", children: [
      /* @__PURE__ */ jsx(
        Avatar.Image,
        {
          accessibilityLabel: "Nate Wienert",
          src: "https://images.unsplash.com/photo-1531384441138-2736e62e0919?&w=100&h=100&dpr=2&q=80"
        }
      ),
      /* @__PURE__ */ jsx(Avatar.Fallback, { delayMs: 600, backgroundColor: "$blue10" })
    ] })
  ] });
}
export {
  AvatarDemo
};
//# sourceMappingURL=AvatarDemo.js.map
